import { useTheme } from "styled-components";
import { typographyTypes } from "theme/interpolations/fontFamily";

import { colorIsLight } from "Utilities/Colors/colorUtils";

import { useFnrTextButtonContext } from "./FnrTextButton";

const useFontType = () => {
  const { isLegacy, emphasized } = useFnrTextButtonContext();
  if (isLegacy) return undefined;
  if (emphasized) return typographyTypes.accent;
  return typographyTypes.copy;
};

const useIsBold = () => {
  const { isLegacy, emphasized } = useFnrTextButtonContext();
  if (isLegacy && emphasized) return true;
  if (!isLegacy && emphasized) return false; // already using accent type, don't overdo it!

  // This should never happen. But just in case...
  return emphasized;
};

const useTextColor = () => {
  const {
    isDark,
    isHoverFocused,
    isLegacy,
    subtleHover,
    hoverColor: hoverColorArg,
    color: colorArg,
    noBackgroundColor,
    active,
  } = useFnrTextButtonContext();
  const { palette, colors } = useTheme();
  const color = palette[colorArg] || colors[colorArg] || colorArg;
  const hoverColor =
    palette[hoverColorArg] || colors[hoverColorArg] || hoverColorArg;

  const isLight = colorIsLight(color);
  if ((isHoverFocused && !subtleHover) || active) {
    if (hoverColor) return hoverColor;
    if (noBackgroundColor) return "brandFnBlue";
    return isLight ? "textBlack" : "textLight";
  }
  if (isDark) return "textLight";
  if (isLegacy) return "textSecondary";
  return color || "taupe";
};

export { useFontType, useIsBold, useTextColor };
